import global from "./resources/global"
import lead from "./resources/lead"
import users from "./resources/users"

export default {
  lead,
  users,
  global,
}
